import FormData from '@/classes/form/FormData'
import caseApi from '@/api/case/caseApi'
import { ReviewResult, ReviewResultState } from '@/classes/case/ReviewResult'

const state = {
  selectedReviewResult: {},
  reviewResults: [],
  reviewResultsFindings: []
}

const getters = {
  getReviewResultForId: state => (id) => {
    return state.reviewResults.find((reviewResult) => {
      return reviewResult.id === parseInt(id)
    })
  },
  getReviewResultFindings: (state, getters) => {
    return getters.getReviewResultsNotOK
  },
  getReviewResultsNotOK: state => {
    return state.reviewResults.filter(reviewResult => reviewResult.state.value === ReviewResultState.NOT_OK)
  },
  getAllReviewResultFindings: state => {
    state.reviewResults.forEach(reviewResult => {
      if (!reviewResult.triggerWatcher && reviewResult.hasFinding() && !containsObject(reviewResult, state.reviewResultsFindings)) {
        state.reviewResultsFindings.push(reviewResult)
      }
    })
    return state.reviewResultsFindings
  },
  getFindingsForResponsible: (state, getters) => (profileType) => {
    return getters.getReviewResultFindings.filter(reviewResult => {
      return reviewResult.responsible.profileType === profileType
    })
  },
  groupedReviewResults: state => (dataGroups) => {
    let groups = [].concat(dataGroups) // Ensures array
    return state.reviewResults.filter(reviewResult => {
      return groups.includes(reviewResult.getDataGroup())
    })
  },
  getReviewResultsForType: state => (reviewResults, dataTypes) => {
    let types = [].concat(dataTypes) // Ensures array
    return reviewResults.filter(reviewResult => {
      return types.includes(reviewResult.getDataType())
    })
  },
  getReviewResultsWithComments: state => {
    return state.reviewResults.filter((reviewResult) => {
      return reviewResult.comments.length || reviewResult.triggerToggle
    })
  }
}

const mutations = {
  setSelectedReviewResult: (state, reviewResult) => {
    state.selectedReviewResult = reviewResult
  },
  setStateReviewResults: (state, data) => {
    state.reviewResults = ReviewResult.asReviewResults(data)
  },
  clearReviewResultsFindings: (state) => {
    state.reviewResultsFindings = []
  },
  updateStateReviewResult: (state, data) => {
    data.current.updateFromResult(ReviewResult.asReviewResult(data.updated))
  },
  updateStateReviewResults: (state, data) => {
    ReviewResult.updateListFormResults(data.current, ReviewResult.asReviewResults(data.updated))
  },
  setStateReviewResultState: (state, data) => {
    data.reviewResult.setState(data.state)
  },
  setResponsibleOnResult: (state, data) => {
    data.reviewResult.setResponsible(data.responsible)
  },
  addOrSetPendingFinding: (state, data) => {
    data.reviewResult.addOrSetPendingFinding(data)
  },
  addPendingComment: (state, data) => {
    data.finding.addPendingComment(data.user)
  },
  commmitPendingComment: (state, data) => {
    data.finding.commitPendingComment()
  },
  commitPendingFinding: (state, reviewResult) => {
    reviewResult.commitPendingFinding()
  }
}

const actions = {
  getReviewResults ({ commit }, caseId) {
    return caseApi.getReviewResults(caseId).then((response) => {
      commit('setStateReviewResults', response.data)
    }).catch((err) => {
      throw err
    })
  },
  updateReviewResultFormData ({ commit }, reviewResult) {
    const payload = FormData.serializeFormDatas([reviewResult.formData])
    return caseApi.patchReviewResult(reviewResult, payload).then((response) => {
      commit('updateStateReviewResult', {
        current: reviewResult,
        updated: response.data
      })
      return true
    }).catch((err) => {
      throw err
    })
  },
  updateReviewResultState ({ commit }, data) {
    let payload = { state: ReviewResultState.getStateByValue(data.state) }
    return caseApi.patchReviewResultState(data.reviewResult, payload).then((response) => {
      commit('updateStateReviewResult', {
        current: data.reviewResult,
        updated: response.data
      })
      return true
    }).catch((err) => {
      throw err
    })
  },
  updateAllReviewResultsState ({ commit }, patchData) {
    return caseApi.patchReviewResultsState(patchData.caseId, patchData.reviewResults).then((response) => {
      commit('updateStateReviewResults', {
        current: patchData.current,
        updated: response.data
      })
      return true
    }).catch((err) => {
      throw err
    })
  },
  saveFinding ({ commit }, reviewResult) {
    return caseApi.postFinding(reviewResult.id, reviewResult.finding).then((response) => {
      commit('updateStateReviewResult', {
        current: reviewResult,
        updated: response.data
      })
    }).catch((err) => {
      throw err
    })
  },
  updateFinding ({ commit }, reviewResult) {
    return caseApi.patchFinding(reviewResult.finding).then((response) => {
      commit('updateStateReviewResult', {
        current: reviewResult,
        updated: response.data
      })
    }).catch((err) => {
      throw err
    })
  },
  saveComment ({ commit }, postData) {
    let payload = { text: postData.comment }
    return caseApi.postFindingComment(postData.finding.id, payload).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  saveRejectComment ({ commit }, postData) {
    let payload = {
      text: postData.comment,
      responsible: postData.responsible
    }
    return caseApi.postFindingComment(postData.finding.id, payload).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  clearReviewResults ({ commit }) {
    commit('setStateReviewResults', [])
  },
  clearReviewResultsFindings ({ commit }) {
    commit('clearReviewResultsFindings')
  }
}

function containsObject (obj, list) {
  for (let object of list) {
    if (object.id === obj.id) {
      return true
    }
  }
  return false
}

export default {
  state,
  getters,
  mutations,
  actions
}
